import React from 'react';
import { siteData } from '../data';
import { Check, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

export default function About() {
  const benefits = [
    "Erfarne og certificerede massører",
    "Autentiske thailandske teknikker",
    "Afslappende og rolige omgivelser",
    "Fokus på din krops balance"
  ];

  return (
    <section id="om-os" className="pt-0 pb-24 lg:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-stretch">
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="lg:w-1/2 w-full"
        >
          <div className="h-72 sm:h-80 lg:h-[450px] w-full">
            <img
              src="https://assets.auxodev.dk/assets/827bf07b-63d5-4b3e-a53e-0e890a6a1d87/22c63cb7-f7d2-4ba6-a0c7-cbec855b96e4.jpg"
              alt="Massage behandling"
              className="w-full h-full object-cover rounded-none sm:rounded-2xl"
            />
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="lg:w-1/2 w-full flex flex-col justify-center px-4 sm:px-0 lg:pl-16 mt-10 lg:mt-0"
        >
          <h2 className="text-3xl sm:text-4xl font-prata font-medium text-stone-900 mb-3 uppercase tracking-tight">
            {siteData.about.title}
          </h2>
          <p className="text-lg text-stone-600 mb-4 leading-relaxed">
            {siteData.about.content}
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center space-x-4">
                <Check className="w-8 h-8 text-black flex-shrink-0" />
                <span className="text-stone-700 font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          <div>
            <a
              href="#kontakt"
              className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-[#b0a697] hover:bg-[#b0a697]/90 transition-all shadow-lg"
            >
              Bestil tid i dag
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
